export const bundleProducts = {
  package2FuturePow: "package_2_future_pow",
} as const;
